import { useCompanyStore } from "@/entities/company/model";
import { useDeviceStore } from "@/entities/device/model";
import { useEvaluationStore } from "@/entities/evaluation/model";
import { useGlobalStore } from "@/shared/model";

/**
 * Запуск trade-in без покупаемого устройства (только сдача).
 * Живёт в слое features, а не в global-сторе: при старте нужно сбрасывать
 * сторы сущностей и фич, а shared не может их импортировать
 */
export function useStartTradeIn() {
    const globalStore = useGlobalStore();
    const companyStore = useCompanyStore();
    const deviceStore = useDeviceStore();
    const evaluationStore = useEvaluationStore();

    return function startTradeIn(): void {
        // Every start begins from scratch (useStoreResetter in v2)
        deviceStore.reset();
        companyStore.reset();
        evaluationStore.reset();
        globalStore.resetStep();
        // Enables the widget data query, it is loaded only once
        globalStore.isStarted = true;
        globalStore.openWidget();
    };
}
